Ext.define('SA.EditPanelEnabledSectionController', {
    constructor({itemFactory}) {
        this.itemFactory = itemFactory;
        this.view = Ext.widget({xtype: 'edit-panel-enabled-section'});
    },

    createItem(id) {
        if (!this.onItemChangeCallback) {
            return this.itemFactory(id);
        }

        var item = this.itemFactory(id);
        item.on('change', this.onItemChangeCallback, this);
        return item;
    },

    eachItem(callback) {
        this.view.eachItem(callback);
    },

    findItem(id) {
        return this.view.findItem(id);
    },

    getIds() {
        return this.view.getIds();
    },

    getView() {
        return this.view;
    },

    onItemChange(callback, scope) {
        this.onItemChangeCallback = (...args) => Ext.callback(callback, scope, args);
    },

    setIds(ids) {
        var items = ids.map(id => this.findItem(id) ?? this.createItem(id));

        this.view.syncItems(items);
    }
});